export default "__VITE_ASSET__69a62cb7__"